"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallOfTheWildAbilityHandler = exports.CallOfTheWildActorAbilityFactory = exports.CallOfTheWildAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const enums_1 = require("../../core/enums");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_1 = require("../../core/event-handlers/core");
const Record_1 = require("../../utils/Record");
function mkRangerCat(ranger) {
    let args = new ActorArgs_1.NpcActorArgs(ranger.faction, ActorType_1.ActorType.RangerPet, ranger.level, 
    // attributes...
    Object.entries(ranger.maxAttributeValues).reduce((pet, [key, value]) => {
        let multiplier = .85;
        switch (+key) {
            case enums_1.AttributeType.Health:
                multiplier = 1;
                break;
        }
        pet[key] = Math.round(value * multiplier);
        return pet;
    }, {}), 
    // abilities...
    {
        // Bite		0	Cat	0
        [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("Bite").mk(),
        // Claw		1 turn	Cat	5
        [enums_1.AbilitySlot.Ability2]: ranger.level >= 5 && Registries_1.ActorAbilities.getItem("Claw").mk(),
        // Roar		3 turns	Cat	10
        [enums_1.AbilitySlot.Ability3]: ranger.level >= 10 && Registries_1.ActorAbilities.getItem("Roar").mk(),
        // Swipe		4 turns	Cat	20
        [enums_1.AbilitySlot.Ability4]: ranger.level >= 20 && Registries_1.ActorAbilities.getItem("Swipe").mk(),
        // Pounce		2 turns	Cat	25
        [enums_1.AbilitySlot.Ability5]: ranger.level >= 25 && Registries_1.ActorAbilities.getItem("Pounce").mk()
    })
        .withPlayerId(ranger.playerId);
    if (ranger.faction !== enums_1.Faction.Ally) {
        args = args.withAi("Rando", {});
    }
    return args;
}
function mkRangerDragonWhelp(ranger) {
    let args = new ActorArgs_1.NpcActorArgs(ranger.faction, ActorType_1.ActorType.DragonWhelp, ranger.level, 
    // attributes...w
    Object.entries(ranger.maxAttributeValues).reduce((pet, [key, value]) => {
        let multiplier = .85;
        switch (+key) {
            // Power is intentionally left the same
            case enums_1.AttributeType.Focus:
                value = (0, Record_1.getValueOrDefault)(ranger.maxAttributeValues, enums_1.AttributeType.Power, 1);
                break;
            case enums_1.AttributeType.Health:
                multiplier = 1;
                break;
        }
        pet[key] = Math.round(value * multiplier);
        return pet;
    }, {}), 
    // abilities...
    {
        [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("COW_DragonWhelp_Flare").mk(),
        [enums_1.AbilitySlot.Ability2]: ranger.level >= 5 && Registries_1.ActorAbilities.getItem("COW_DragonWhelp_Cauterize").mk(),
        [enums_1.AbilitySlot.Ability3]: ranger.level >= 10 && Registries_1.ActorAbilities.getItem("COW_DragonWhelp_Scorch").mk(),
        [enums_1.AbilitySlot.Ability4]: ranger.level >= 20 && Registries_1.ActorAbilities.getItem("COW_DragonWhelp_Kindle").mk(),
        [enums_1.AbilitySlot.Ability5]: ranger.level >= 25 && Registries_1.ActorAbilities.getItem("COW_DragonWhelp_FireBreath").mk()
    })
        .withPlayerId(ranger.playerId);
    if (ranger.faction !== enums_1.Faction.Ally) {
        args = args.withAi("Rando", {});
    }
    return args;
}
class CallOfTheWildAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CallOfTheWild;
        this.__typeName = "CallOfTheWild";
    }
}
exports.CallOfTheWildAbilityArgs = CallOfTheWildAbilityArgs;
let CallOfTheWildActorAbilityFactory = class CallOfTheWildActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CallOfTheWild", "Self", 0);
    }
};
CallOfTheWildActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CallOfTheWild")
], CallOfTheWildActorAbilityFactory);
exports.CallOfTheWildActorAbilityFactory = CallOfTheWildActorAbilityFactory;
let CallOfTheWildAbilityHandler = class CallOfTheWildAbilityHandler {
    init(sequence, container, actorId) {
        let petArgs;
        switch (true) {
            case container.hasAttribute(actorId, "Charm_Ranger_0"):
                petArgs = mkRangerDragonWhelp(container.getActor(actorId));
                break;
            default:
                petArgs = mkRangerCat(container.getActor(actorId));
                break;
        }
        const petId = container.addCompanion(sequence, actorId, petArgs);
        container.registerEventHandler(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_1.RemoveActorEventHandlerArgs(petId));
    }
    activate(sequence, container, ability) {
        throw new Error(`PASSIVE_ONLY`);
    }
};
CallOfTheWildAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CallOfTheWild)
], CallOfTheWildAbilityHandler);
exports.CallOfTheWildAbilityHandler = CallOfTheWildAbilityHandler;
